export default __webpack_public_path__ + "static/news-section-outside-image-63ad1dca7455793172c088d659976bac.webp";